import script from "./FormSuratPernyataanDukungan.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSuratPernyataanDukungan.vue?vue&type=script&setup=true&lang=js"

import "./FormSuratPernyataanDukungan.vue?vue&type=style&index=0&id=456e5e43&lang=css"

const __exports__ = script;

export default __exports__